// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1006":"dfb36c18","3710":"e8e73ab5","61094":"dfb36c18"}[chunkId] + ".chunk.css";
};